import React, { useState, useEffect } from 'react';
import { Button, MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';
import axios from 'axios';
import { useStore } from 'react-redux';

export default function PaymentRequest() {
  const store: any = useStore();

  const [loading, setLoading] = useState(false);
  const [paymentRequest, setPaymentRequest] = useState<any>(null);
  const [selectedMethod, setSelectedMethod] = useState('BANK_TRANSFER');

  async function fetchPaymentRequest() {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_SERVER}/payment-requests/active`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      });
      setPaymentRequest(response.data);
    } catch (error) {
      console.error('Error fetching payment request:', error);
    }
  }

  async function createPaymentRequest() {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_SERVER}/payment-requests`,
        { method: selectedMethod },
        {
          headers: {
            Authorization: `Bearer ${store.getState().auth.jwt}`,
          },
        },
      );
      setPaymentRequest(response.data);
    } catch (error) {
      console.error('Error creating payment request:', error);
    } finally {
      setLoading(false);
    }
  }

  async function cancelPaymentRequest() {
    try {
      await axios.delete(`${process.env.REACT_APP_API_SERVER}/payment-requests`, {
        headers: {
          Authorization: `Bearer ${store.getState().auth.jwt}`,
        },
      });
      setPaymentRequest(null);
    } catch (error) {
      console.error('Error canceling payment request:', error);
    }
  }

  const handleMethodChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedMethod(event.target.value as string);
  };

  useEffect(() => {
    let isActive = true;
    async function fetchData() {
      fetchPaymentRequest();
    }
    fetchData();
    return () => {
      isActive = false;
    };
  }, []);

  return (
    <div className="payment-request-container" style={{ padding: '20px' }}>
      {paymentRequest ? (
        <div className="payment-request-status" style={{ marginBottom: '20px' }}>
          <h3>Payment Request</h3>
          <p>
            Status: <b>{paymentRequest.status}</b>
          </p>
          <p>
            Method: <b>{paymentRequest.method || selectedMethod}</b>
          </p>
          <Button
            variant="contained"
            color="secondary"
            onClick={cancelPaymentRequest}
            className="cancel-button"
            style={{ marginTop: '10px' }}
          >
            Cancel Request
          </Button>
        </div>
      ) : (
        <div className="payment-request-form" style={{ marginBottom: '20px' }}>
          <h3>Create Payment Request</h3>
          <br />
          <FormControl fullWidth style={{ marginBottom: '20px' }}>
            <InputLabel id="payment-method-label">Select Payment Method</InputLabel>
            <Select
              labelId="payment-method-label"
              id="paymentMethod"
              value={selectedMethod}
              onChange={handleMethodChange}
            >
              <MenuItem value="BANK_TRANSFER">Bank Transfer</MenuItem>
              <MenuItem value="CASH">Cash</MenuItem>
              <MenuItem value="BKASH">BKash</MenuItem>
              <MenuItem value="ROCKET">Rocket</MenuItem>
              <MenuItem value="NAGAD">Nagad</MenuItem>
            </Select>
          </FormControl>
          <Button
            onClick={createPaymentRequest}
            variant="contained"
            color="primary"
            disabled={loading}
            className="submit-button"
            style={{ marginTop: '10px' }}
          >
            {loading ? 'Processing...' : 'Submit Request'}
          </Button>
        </div>
      )}
    </div>
  );
}
